export var FileIconFont;
(function (FileIconFont) {
    FileIconFont["AUDIO"] = "mi-icon-audio";
    FileIconFont["VIDEO"] = "mi-icon-document-movie";
    FileIconFont["PDF"] = "mi-icon-document-pdf";
    FileIconFont["EXCEL"] = "mi-icon-document-excel";
    FileIconFont["WORD"] = "mi-icon-document-word";
    FileIconFont["GENERIC"] = "mi-icon-document-generic";
})(FileIconFont || (FileIconFont = {}));
//# sourceMappingURL=FileIconFont.js.map